import { create } from 'zustand';
import { CommandStore } from './types';

export const useCommandStore = create<CommandStore>((set, get) => ({
  subscriptions: [],
  dispatch(commands) {
    for (const sub of get().subscriptions) {
      const commands_to_send = commands.filter(
        (cmd) => sub.type === cmd.type || sub.types?.includes(cmd.type)
      );

      if (commands_to_send.length) {
        sub.callback(commands_to_send);
      }
    }
  },
  subscribe(subscription) {
    set(({ subscriptions }) => ({
      subscriptions: subscriptions.some((sub) => sub.id === subscription.id)
        ? subscriptions.map((sub) =>
            sub.id === subscription.id ? subscription : sub
          )
        : [...subscriptions, subscription],
    }));
  },
  unsubscribe(id) {
    set(({ subscriptions }) => ({
      subscriptions: subscriptions.filter((sub) => sub.id !== id),
    }));
  },
}));
